import { alpha, Box, keyframes, Popper, styled } from '@mui/material';

export const HintTarget = styled(Box)(({ theme: _theme }) => ({
    position: 'relative',
    width: '100%',
}));

export const HintBody = styled(Popper)<{ size?: string }>(({ theme: _theme }) => ({
    zIndex: 1001,
    paddingLeft: '12px',
}));

export const HintBullet = styled(Box)<{ active: boolean }>(({ active, theme }) => [
    {
        width: '6px',
        height: '6px',
        borderRadius: '50%',
        background: theme.custom.c1,
    },
    active && {
        background: theme.palette.secondary.main,
        width: '8px',
        height: '8px',
    },
]);

export const HintContentWrap = styled(Box)<{ size?: string }>(({ theme, size }) => ({
    width: size === 'large' ? '428px' : '362px',
    borderRadius: '12px',
    padding: '24px',
    background: alpha(theme.custom.c24, 0.98),
}));

export const HintAngle = styled(Box)<{
    blockSize?: { width: number; height: number };
    placement: string;
}>(({ theme, blockSize, placement }) => [
    {
        width: '12px',
        height: '30px',
        overflow: 'hidden',
        position: 'absolute',
        right: '100%',
        '&:before': {
            content: '""',
            position: 'absolute',
            left: '10%',
            top: '50%',
            display: 'block',
            background: alpha(theme.custom.c24, 0.98),
            width: '20px',
            height: '20px',
            transform: 'rotate(-45deg) skew(10deg, 10deg)',
            transformOrigin: 'top left',
        },
    },
    placement === 'right-start' &&
        blockSize && {
            transform: 'translateY(-50%)',
            top: `${blockSize.height / 2}px`,
        },
    placement === 'right-end' &&
        blockSize && {
            transform: 'translateY(50%)',
            bottom: `${blockSize.height / 2}px`,
        },
]);

const blinkItem = keyframes`
    0% {
        opacity: 0.2;
    }
    50% {
        opacity: 0.50 
    }
    100% {
        opacity: 0.2 
    }
`;

const showBlinkItem = keyframes`
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1; 
    }
`;

export const HintMenuAnimation = styled(Box)(({ theme }) => ({
    width: '36px',
    height: '36px',
    zIndex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    border: `1px solid ${theme.palette.secondary.main}`,
    borderRadius: '50%',
    opacity: 0,
    animation: `${showBlinkItem} 0.3s ease-in-out 0s forwards`,
    '&:before': {
        content: '""',
        display: 'block',
        borderRadius: '50%',
        background: theme.palette.secondary.main,
        animation: `${blinkItem} 2.5s ease-in-out 0s infinite`,
        opacity: 0.5,
        position: 'absolute',
        top: '1px',
        left: '1px',
        right: '1px',
        bottom: '1px',
    },
}));

export const HintAnchor = styled(Box, {
    shouldForwardProp: prop => prop !== 'sideBar',
})<{ variant?: string; sideBar: boolean }>(({ theme: _theme, variant, sideBar }) => [
    {
        position: 'absolute',
        left: 0,
        top: 0,
        width: '100%',
        bottom: 0,
        pointerEvents: 'none',
    },
    variant === 'menu' && {
        width: !sideBar ? '40px' : '100%',
        display: 'flex',
        alignItems: 'center',
    },
]);
